import { CalendarCacheUpdateLog } from './store/schema/CalendarCacheDiagnosticsStore';
import logCacheUpdateForDiagnosticsAsync from './utils/logCacheUpdateForDiagnosticsAsync';

import { LazyImport, LazyModule } from 'owa-bundling';

export { CalendarCacheUpdateLog };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CacheDiagnostics", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLogCacheUpdateForDiagnostics = new LazyImport(
    lazyModule,
    m => m.logCacheUpdateForDiagnostics
);

export { logCacheUpdateForDiagnosticsAsync };
